/*
  ECKBERG — DRS visszaváltási díj a kosárban.

  Minden olyan termék után, amelynek a nevében szerepel a „DRS”, darabonként
  50 Ft visszaváltási díj jár. A díj külön, áfamentes kosártétel (a rejtett
  „DRS visszaváltási díj” termék), nem része a termék árának. Kivétel: ahol
  a díjat már a „Bony Fees & Surcharges” alkalmazás hozzáadta a sorhoz.

  A szkript a kosár minden változása után (és oldalbetöltéskor) megszámolja
  a DRS-es darabokat, és ehhez igazítja a díjsor mennyiségét. A csomagos
  változatoknál („6x200 ml”, „4 x 200 ml”) a csomag darabszáma számít.
  A díjsor mennyiségét a vevő nem tudja kézzel átírni (a kosár sablonja
  mennyiségválasztó nélkül jeleníti meg).
*/
(() => {
  const CFG = window.eckDRS;
  if (!CFG || !CFG.variantId) return;

  const kosarUrl = (window.routes && window.routes.cart_url) || '/cart';
  const frissitUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';

  const csomagDb = (valtozat) => {
    const m = String(valtozat || '').match(/(\d+)\s*[x×]\s*\d/i);
    return m ? parseInt(m[1], 10) : 1;
  };

  // Azokat a sorokat kihagyjuk, amelyekhez a „Bony Fees & Surcharges”
  // alkalmazás már hozzáadta a díjat: ezek a kosárban összetevős sorként
  // jelennek meg (has_components), a díj a sor árában van.
  const kellDb = (cart) =>
    cart.items.reduce((ossz, tetel) => {
      if (tetel.variant_id === CFG.variantId) return ossz;
      if (tetel.has_components) return ossz;
      if (!/\bDRS\b/.test(tetel.product_title || '')) return ossz;
      return ossz + tetel.quantity * csomagDb(tetel.variant_title);
    }, 0);

  const belsoHtml = (html, szelektor) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(szelektor);
    return el ? el.innerHTML : null;
  };

  let fut = false;
  let ujra = false;

  async function szinkron() {
    if (fut) {
      ujra = true;
      return;
    }
    fut = true;
    try {
      const cart = await (await fetch(`${kosarUrl}.js`, { headers: { Accept: 'application/json' } })).json();
      const kell = kellDb(cart);
      const van = cart.items
        .filter((t) => t.variant_id === CFG.variantId)
        .reduce((ossz, t) => ossz + t.quantity, 0);
      if (kell === van) return;

      const fiok = document.querySelector('cart-drawer');
      const szekciok = fiok ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble'];
      const valasz = await fetch(`${frissitUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: { [CFG.variantId]: kell },
          sections: szekciok.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const adat = await valasz.json();

      // Kosároldalon a teljes oldal frissül: így az összesítő, a szállítási
      // sáv és a tételek biztosan egyeznek.
      if (window.location.pathname === kosarUrl) {
        window.location.reload();
        return;
      }

      const s = adat.sections || {};
      const buborek = document.getElementById('cart-icon-bubble');
      if (buborek && s['cart-icon-bubble']) {
        const html = belsoHtml(s['cart-icon-bubble'], '.shopify-section');
        if (html !== null) buborek.innerHTML = html;
      }
      if (fiok && s['cart-drawer']) {
        const cel = document.getElementById('CartDrawer');
        const html = belsoHtml(s['cart-drawer'], '#CartDrawer');
        if (cel && html !== null) {
          cel.innerHTML = html;
          const takaro = document.getElementById('CartDrawer-Overlay');
          if (takaro) takaro.addEventListener('click', fiok.close.bind(fiok));
        }
        fiok.classList.toggle('is-empty', adat.item_count === 0);
      }
    } catch (e) {
      console.warn('DRS-díj szinkron hiba', e);
    } finally {
      fut = false;
      if (ujra) {
        ujra = false;
        szinkron();
      }
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => szinkron());
  }
  szinkron();
})();
